import { render, staticRenderFns } from "./r-sex.vue?vue&type=template&id=3f2ad298&"
import script from "./r-sex.vue?vue&type=script&lang=js&"
export * from "./r-sex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports